import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { data } from '../../evn/evn'; // Ensure the correct path is used
import Sidebar from '../AdminComponents/SideBar';
import styles from './NoteManagement.module.css'; // Ensure this path matches your CSS file structure

const NoteManagement = () => {
  const [notes, setNotes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotes = async () => {
      const ip = data.evn; // Ensure 'evn' is correct
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }
      

      try {
        const response = await axios.get(`${ip}/admin/notes`, {
          headers: { 'x-auth-token': token },
        });
        setNotes(response.data.notes);
        setSearchResults(response.data.notes);
      } catch (error) {
        console.error("There was an error fetching the notes:", error);
      }
    };

    fetchNotes();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(notes);
    } else {
      const filteredNotes = notes.filter(note =>
        searchType === 'id' ? note.id.toString().includes(event.target.value)
                            : note.case_id.toString().includes(event.target.value));
      setSearchResults(filteredNotes);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(notes);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchNotes = notes.filter(note => {
        if (searchType === 'id') return note.id.toString() === searchTerm;
        return note.case_id.toString() === searchTerm;
      });
      setSearchResults(exactMatchNotes);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by ID</option>
            <option value="caseId">Search by Case ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>ID</th>
              <th className={styles.tableHeader}>Case ID</th>
              <th className={styles.tableHeader}>Note</th>
              <th className={styles.tableHeader}>Created At</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((note) => (
              <tr key={note.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{note.id}</td>
                <td className={styles.tableCell}>{note.case_id}</td>
                <td className={styles.tableCell}>{note.note}</td>
                <td className={styles.tableCell}>{new Date(note.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NoteManagement;
